  /*============Get Auth tagHistory Controller
          ================================*/
  angular
    .module('vppApp') 
    .controller('viewTagController', viewTagController);

  viewTagController.$inject = ['$scope', 'apiFactory', '$stateParams', 'vppConfig', 'dateFilter', 'AuthenticationService', 'CustomerService', '$timeout', '$state', 'ProgramInfoService'];

  function viewTagController($scope, apiFactory, $stateParams, vppConfig, dateFilter, AuthenticationService, CustomerService, $timeout, $state, ProgramInfoService) {
    // var accountId = AuthenticationService.getAuthenticatedID();

    // $scope.programIDs = []
    // var id;

    // var onCustomerLoaded = function(customer) {
    //   if (customer) {
    //     accountId = AuthenticationService.getAuthenticatedID();

    //     $scope.programIds = customer.programIDs;
    //     var program = customer.programIDs.filter(x => x.code.toLowerCase() === 'vts')[0];
    //     id = program ? program.programID : '';

    //     apiFactory.vtHistory(accountId, id).then(function(response) {
    //       $scope.tagHistory = response.data.vehicleTagHistoryList;

    //       for (var i = 0; $scope.tagHistory.length > i; i++) {
    //         $scope.vin = $scope.tagHistory[i].vin;
    //         $scope.year = $scope.tagHistory[i].year;
    //         $scope.make = $scope.tagHistory[i].make;
    //         $scope.model = $scope.tagHistory[i].model;
    //         $scope.locationState = $scope.tagHistory[i].locationState;
    //         $scope.status = $scope.tagHistory[i].status;
    //         $scope.vtsTagType = $scope.tagHistory[i].vtsTagType;
    //         $scope.tagID = $scope.tagHistory[i].tagID;
    //         $scope.accountDetail = $scope.tagHistory[i].accountDetail;
    //         $scope.programPortfolioCode = $scope.tagHistory[i].programPortfolioCode;
    //         $scope.dateEntered = $scope.tagHistory[i].dateEntered;
    //         // $scope.getAvailDate = new Date($scope.tagHistory[i].availabilityDate);
    //         $scope.availabilityDate = $scope.tagHistory[i].availabilityDate;
    //         // $scope.getStatusDate = new Date($scope.tagHistory[i].dateEntered);
    //         // console.log('this statusdate ' +  $scope.tagHistory[i].dateEntered);
    //       }
    //     }, function errorCallback(response) {
    //       $scope.responsePending = false;
    //       $scope.serverError = response.data.errors;
    //     });
    //   } else {
    //     $scope.programIds = [];
    //   }
    // };

    var accountId = AuthenticationService.getAuthenticatedID();

    $scope.programIDs = []

    var i = 0;
    var id = 0;
    $timeout(function(){
      var programIds = CustomerService.getProgramIDs();
      for(var i = 0; i < programIds.length; i++){
        if(programIds[i].code.toLowerCase() === 'vts'){
          id = programIds[i].programID;
        }
      }

      if(id > 0) {
        apiFactory.vtHistory(accountId, id).then(function(response) {
          $scope.tagHistory = response.data.vehicleTagHistoryList;

          for (var i = 0; $scope.tagHistory.length > i; i++) {
            $scope.vin = $scope.tagHistory[i].vin;
            $scope.year = $scope.tagHistory[i].year;
            $scope.make = $scope.tagHistory[i].make;
            $scope.model = $scope.tagHistory[i].model;
            $scope.locationState = $scope.tagHistory[i].locationState;
            $scope.status = $scope.tagHistory[i].status;
            $scope.vtsTagType = $scope.tagHistory[i].vtsTagType;
            $scope.tagID = $scope.tagHistory[i].tagID;
            $scope.accountDetail = $scope.tagHistory[i].accountDetail;
            $scope.programPortfolioCode = $scope.tagHistory[i].programPortfolioCode;
            $scope.dateEntered = $scope.tagHistory[i].dateEntered;
            // $scope.getAvailDate = new Date($scope.tagHistory[i].availabilityDate);
            $scope.availabilityDate = $scope.tagHistory[i].availabilityDate;
            // $scope.getStatusDate = new Date($scope.tagHistory[i].dateEntered);
             // console.log('this statusdate ' +  $scope.tagHistory[i].dateEntered);

          }
        }, function errorCallback(response) {
          $scope.responsePending = false;
          $scope.serverError = response.data.errors;
        });
      }
    }, 1000);

    $scope.gotToAuth = function(id) {
      $scope.programInfo = 110244;
      ProgramInfoService.addProgram(id);
      $state.go('get-auth');
    }

    $scope.viewDetail = function(){
      var vin = $scope.vin;
      apiFactory.vtDetail(accountId, id, vin).then(function(response){
        $scope.vDetails = response.data;

      }, function errorCallback(response) {
        $scope.responsePending = false;
        $scope.serverError = response.data.errors;
      })
    }
    
    $scope.goOverview = function(id){
      var programName = 'Vehicle Tagging';

      ProgramInfoService.addProgram(id);
      $state.go('overview');
      console.log('program name is ' + programName);
    }

    // CustomerService.addObserver(onCustomerLoaded);

    // $scope.$on("$destroy", function() {
    //   CustomerService.removeObserver(onCustomerLoaded);
    // });

  };
